module.exports = __webpack_public_path__ + "img/info3.d8360e4b.webp";